
import React, { useState, useEffect } from 'react';
import { Box, Button, Grid, InputLabel, ListItemText, MenuItem, TextField, Select, Checkbox, ListItemIcon, TextFieldProps, Autocomplete, } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { useDispatch } from 'react-redux';
import clsx from 'clsx';
import FileSaver from 'file-saver';
import FileUploader from '../../file-loader';
import { messageReplayService } from '../../../store/admin/message-replay/actions';
import useStyles from './styles';

const csvMessageReplayString = 'Record Id,Device Key';
type SelectOption = {
    value: string;
    title: string;
};
const replayTypes: SelectOption[] = [{ value: 'blob', title: 'Blob' }, { value: 'sql', title: 'SQL' }, {
    value: 'iotmessage', title: 'IoT Message'
}, { value: 'fileinfo', title: 'File Info' }, { value: 's3', title: 'S3' }];

const requestedByOptions = ['ALL', 'SUMMARY_PMM', 'BAASS', 'VL2.0', 'VL3.0', 'CAT_APP', 'TERRA', 
'RAM', 'RFV', 'PMM', 'WTM', 'MINESTAR_EDGE', 'SURFACE_MANAGEMENT', 'SUPERCOMM', 'RS_SKYWALKER', 
'RS_JULIO', 'FORESIGHT', 'UTILIZATION_MANAGEMENT', 'ALERTS_AND_NOTIFICATIONS', 'HISTORY', 'TDH'];

const MessageReplay = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const boxProperties = {
        p: 3,
        className: classes.box,
    };
    const [percentUpload, setPercentUpload] = useState<number>(0);
    const [fileToPush, setFileToPush] = useState<any>();
    const [replayType, setReplayType] = useState<string>();
    const [requestedBy, setRequestedBy] = useState<String[]>([]);
    const [changeTicketNumber, setChangeTicketNumber] = useState<string>();

    /* eslint-disable unicorn/consistent-function-scoping */
    const createTemplate = (headerString: string, fileName: string) => {
        const templateString = new Blob([headerString], {
            type: 'text/csv',
        });
        FileSaver.saveAs(templateString, fileName);
    };
    const downloadTemplate = () => {
        createTemplate(csvMessageReplayString, 'message_replay.csv');
    };
    const handleChange = (event: any) => {
        const {
            target: { value },
        } = event;
        setRequestedBy(
            typeof value === 'string' ? value.split(',') : value,
        );
    };
    const fileHandler = async (file: any) => {
        setFileToPush(file);
        const queryParameters = { replayType, requestedBy, changeTicketNumber };
        const data = {
            file,
            setPercentUpload,
            queryParameters
        };
        await dispatch(messageReplayService(data));
    };

    return (
        <Grid container direction="row" alignItems="stretch">
            <Grid item xs={12} >
                <Box {...boxProperties}>
                    <InputLabel className={classes.textLabel}>Replay Type</InputLabel>
                    <Select
                        variant="standard"
                        id="replayType"
                        value={replayType || 'select'}
                        onChange={(event) => setReplayType(event.target.value as string)}
                        className={classes.dropdown}
                    >
                        <MenuItem value="select" >
                            <em className={classes.unSelected}>Select</em>
                        </MenuItem>
                        {(replayTypes as Array<SelectOption>).map((o: SelectOption) => (
                            <MenuItem value={o.value}>{o.title}</MenuItem>
                        ))}
                    </Select>
                    <InputLabel className={classes.textLabel}>Requested By</InputLabel>
                    <Select
                        variant="standard"
                        id="requestedBy"
                        multiple
                        value={(requestedBy && requestedBy) || 'select'}
                        onChange={handleChange}
                        className={classes.dropdown}
                        renderValue={(selected) => selected.join(', ')}
                    >
                        {requestedByOptions.map((option: any, index) => (
                            <MenuItem key={option} value={option} id={`item-${index}`} className={classes.menuItems}>
                                <Checkbox
                                    checked={requestedBy.includes(option)}
                                />
                                <ListItemText primary={option} />
                            </MenuItem>
                        ))}
                    </Select>
                    <InputLabel className={classes.textLabel}>Change Ticket Number</InputLabel>
                    <TextField
                        variant="standard"
                        id="changeTicketNumber"
                        className={classes.textfield}
                        value={changeTicketNumber}
                        onChange={(event) => setChangeTicketNumber(event.target.value as string)}
                    />
                </Box>
            </Grid>

            <Grid item xs={12} lg={4} >
                <Box className={classes.buttonWrap}>
                    <Button
                        className={clsx(classes.button)}
                        variant="outlined"
                        size="small"
                        onClick={() => downloadTemplate()} >
                        Download Template
                    </Button>
                    <FileUploader
                        text="Upload CSV" handleFile={fileHandler} />
                </Box>
            </Grid>
        </Grid>
    );
};
export default MessageReplay;